const STORAGE_KEY = 'momy.web-escola.sidebar.retraida';

export function loadSidebarRetraida(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function saveSidebarRetraida(retraida: boolean): void {
  localStorage.setItem(STORAGE_KEY, String(retraida));
}
